import React, { memo, useState } from "react";
import { Grid, Container } from "@mui/material";
import DeliveryHead from "../DeliveryHead";
import { Formik, Form, Field, ErrorMessage } from "formik";
import AuthInput from "../../../shared/authinput";
import MainButton from "../../../shared/Button";
import QuotationOrderDetails from "./QuotationOrderDetails";
import CommonPhoneInputs from "../../../shared/authinput/CommonPhoneInputs";
import {
  PhoneInputsMain,
  CustomLabel,
} from "../../../shared/commonstyle/PhoneStyle";
import { isValidPhoneNumber } from "react-phone-number-input";
import AutocompleteLocations from "../../../shared/map/AutocompleteLocations";
import { AutocompleteMain } from "../../../shared/map/AutocompleteStyle";
import {
  PickupDetailsMain,
  InputFlexWrap,
} from "../styles/DeliveryDetailsStyle";
import { DeliveryDetailsvalidation } from "../../../../helpers/validations/delivery/DeliverySteps";
import { useDispatch, useSelector } from "react-redux";
import { SetDeliverySteps } from "../../../../redux/slice/deliverysteps/DeliveryStepsSlice";
import { toast } from "react-hot-toast";

const DeliveryDetails = ({ NavigateCallback }) => {
  const DeliverySteps = useSelector((state) => state.deliverysteps.steps);
  const dispatch = useDispatch();
  const [showNext, setShowNext] = useState(false);
  const [PhoneError, SetPhoneError] = useState(false);
  const [pickupDetails, SetpickupDetails] = useState({});

  const ShowPreviusPage = () => {
    NavigateCallback(false);
  };

  const handleChange = (value, event, form) => {
    SetPhoneError(false);
    if (event?.nativeEvent?.inputType === "deleteContentBackward" && !value) {
      event.preventDefault();
      return;
    }
    const isNonString = typeof value !== "string";
    if (isNonString || value === "") {
      form.setFieldValue("phoneNumber", value);
      form.setFieldError("phoneNumber", "");
    } else {
      const isValid = isValidPhoneNumber(value);
      form.setFieldValue("phoneNumber", value);
      form.setFieldError(
        "phoneNumber",
        isValid ? undefined : "Invalid phone number"
      );
    }
  };

  const handleSubmit = (values, { resetForm }) => {
    const { phoneNumber } = values;
    const isValid = isValidPhoneNumber(phoneNumber);
    if (!isValid) {
      SetPhoneError(true);
      toast.error("Invalid phone number");
      return;
    } else {
      const DetailsValues = { ...values, Location: pickupDetails };
      const DeliveryDetailsSteps = { dropoff: DetailsValues };
      dispatch(SetDeliverySteps({ ...DeliverySteps, ...DeliveryDetailsSteps }));
      setShowNext(true);
      resetForm();
    }
  };

  return (
    <>
      {!showNext ? (
        <>
          <DeliveryHead
            Value={66}
            BackLink="/pickup-details"
            CenterText="Delivery Details "
            StepText="2 of 3"
            showBox={true}
            showLink={true}
            MobileMainText="Delivery Details"
            MobileSubText="Next: Order Details"
            MobileMoreText={true}
            haveCallBack={true}
            CallBackFun={ShowPreviusPage}
          />
          <Container maxWidth="lg">
            <Grid
              container
              spacing={2}
              justifyContent="center"
              alignItems="center"
            >
              <Grid item xs={12} md={10} lg={5}>
                <PickupDetailsMain>
                  <Formik
                    initialValues={{
                      ContactName: "",
                      phoneNumber: "",
                      EmailAddress: "",
                      Location: "",
                    }}
                    validationSchema={DeliveryDetailsvalidation}
                    onSubmit={handleSubmit}
                  >
                    {(formik) => (
                      <Form autocomplete="off">
                        <InputFlexWrap>
                          <Field
                            type="text"
                            name="ContactName"
                            label="Contact Name"
                            component={AuthInput}
                            placeholder="Enter your name"
                          />
                        </InputFlexWrap>
                        {/* <InputFlexWrap>
                          <Field
                            type="number"
                            name="PhoneNumber"
                            label="Phone Number"
                            component={AuthInput}
                            placeholder="Enter your number"
                          />
                        </InputFlexWrap> */}
                        <PhoneInputsMain
                          className={
                            formik.touched.phoneNumber &&
                            formik.errors.phoneNumber &&
                            "is__error"
                          }
                        >
                          <CustomLabel>Phone Number</CustomLabel>
                          <Field name="phoneNumber">
                            {({ field, form }) => (
                              <CommonPhoneInputs
                                {...field}
                                onChange={(value, event) =>
                                  handleChange(value, event, form)
                                }
                              />
                            )}
                          </Field>
                          <ErrorMessage
                            name="phoneNumber"
                            component="span"
                            className="error"
                          />
                        </PhoneInputsMain>

                        <InputFlexWrap>
                          <Field
                            type="text"
                            name="EmailAddress"
                            label="Email Address"
                            component={AuthInput}
                            placeholder="Enter your email"
                          />
                        </InputFlexWrap>

                        <AutocompleteMain>
                          <CustomLabel>Pickup / Drop-off Location</CustomLabel>
                          <Field name="Location">
                            {({ field, form }) => (
                              <AutocompleteLocations
                                {...field}
                                form={form}
                                SetpickupDetails={SetpickupDetails}
                              />
                            )}
                          </Field>
                          <ErrorMessage
                            name="Location"
                            component="span"
                            className="error"
                          />
                        </AutocompleteMain>
                        {/* {PhoneError && (
                          <span
                            className="Phoneerror"
                            style={{
                              color: "red",
                              textTransform: "capitalize",
                            }}
                          >
                            Invalid phone number
                          </span>
                        )} */}
                        <MainButton type="submit" label="Next" MT="110" />
                      </Form>
                    )}
                  </Formik>
                </PickupDetailsMain>
              </Grid>
            </Grid>
          </Container>
        </>
      ) : (
        <QuotationOrderDetails NavigateCallback={setShowNext} />
      )}
    </>
  );
};

export default memo(DeliveryDetails);
